module.exports = __webpack_public_path__ + "media/application/images/ui/icon-search-home-96983b8f888f1d538b0c8701140118e3.png";